import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormFactoryService } from './util-factory/form-factory.service';

@NgModule({
  imports: [ReactiveFormsModule],
  providers: [FormFactoryService],
  exports: [ReactiveFormsModule],
})
export class FormFactoryModule {}
